module.exports = __webpack_public_path__ + "img/wotive-icon.058363a3.svg";